import { ElMessage } from 'element-plus'
import Clipboard from 'clipboard'

function copyText(el) {
  const clipboard = new Clipboard(el);
  clipboard.on('success', function () {
    ElMessage({
      type: 'success',
      message: '已复制'
    })
    clipboard.destroy();
  });
  clipboard.on('error', function () {
    ElMessage({
      type: 'error',
      message: '复制失败'
    })
  });
}

const copy = {
  mounted(el, bidding) {
    // 配置 Clipboard 属性
    el.setAttribute('data-clipboard-text', bidding.value)
    // 解决第一次复制无法成功问题
    el.onmouseenter = () => copyText(el)
    // 进行复制
    el.onclick = () => copyText(el)
  }
}


export default copy
